import { CopyOutlined } from "@ant-design/icons";
import { convertArrayToCSV } from "@src/util/convert-array-to-csv";
import { Button, message, Tooltip } from "antd";

export const DataCopyClipboard: React.FC<{ rawData: any[]; style?: React.CSSProperties }> = ({ rawData, style }) => {
    const [messageApi, contextHolder] = message.useMessage();
    return (
        <>
            {contextHolder}
            <Tooltip title="Copy data">
                <Button
                    onClick={() => {
                        const dataCopy = convertArrayToCSV(rawData);
                        navigator.clipboard.writeText(dataCopy);
                        messageApi.open({
                            type: "success",
                            content: "Copy success!",
                        });
                    }}
                    type="text"
                    style={{ color: "#1677ff", ...style }}
                    icon={<CopyOutlined />}
                />
            </Tooltip>
        </>
    );
};
